import { useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { usePubsub } from 'wsm-lsp-utilities';
import {
	makesLoaded,
	makesResolved,
	setSelectedMakes
} from '../features/make/makeSlice';

const FILTER_UPDATE_TOPIC = 'ws-locations-data/filtered-locations';

export const useMakeFacets = (isReady) => {
	const dispatch = useDispatch();
	const hasResolvedRef = useRef(false);
	const selectedMakes = useSelector((state) => state.make.selectedMakes);

	useEffect(() => {
		if (!isReady || !window.DDC?.LocationsData) {
			return () => {};
		}

		const locationsData = window.DDC.LocationsData;

		const handleLocationsUpdate = () => {
			const facets = locationsData.getMakeFacets() || [];
			dispatch(makesLoaded(facets));
			// Only mark as resolved on the first load — subsequent location
			// updates (postal code / radius changes) should not re-fire this.
			if (!hasResolvedRef.current) {
				dispatch(makesResolved());
				hasResolvedRef.current = true;
			}
		};

		// Derive facets from the current location set immediately
		handleLocationsUpdate();

		// Subscribe for future location updates (postal code / radius changes)
		const unsubscribe = locationsData.registerLocationsNotification(
			handleLocationsUpdate
		);

		return () => {
			if (unsubscribe) {
				unsubscribe();
			}
		};
	}, [isReady, dispatch]);

	const handleFilterChange = useCallback(() => {
		const makes = window.DDC.LocationsData.getActiveMakes();
		if (selectedMakes.some((make) => !makes.includes(make))) {
			// If the current selectedMakes includes any makes that are no longer
			// active, update the Redux state to reflect the change.
			dispatch(setSelectedMakes(makes));
		}
	}, [dispatch, selectedMakes]);

	// Subscribe to filter updates via the shared DDC-bus primitive (gated on
	// isReady; auto-unsubscribes via the subscriber handle).
	usePubsub(FILTER_UPDATE_TOPIC, handleFilterChange, { isReady });
};
